export default "__VITE_ASSET__BD1N6WcP__"